import './Loader.scss'
const Loader = () => (
    <div className="loader">
        <div className="spinner"></div>
        <br />
        <div className='loadermessage'>Please wait while we process your request</div>
    </div>
);
export default Loader;
